/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Collapse, Button, Label, Input, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';

//context imports
import { ThemeContext } from '../../../contexts/ThemeContext';

// service imports
import GeneralService from '../../../services/GeneralService';
import ProviderService from '../../../services/ProviderService';

const PaymentSession = props => {

    const today = moment();

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isSessionOpen, setIsSessionOpen] = useState(false);
    const [duration, setDuration] = useState(0);
    const [session, setSession] = useState({
        time: "",
        date: "",
        modeOfServiceSelected: "",
        isReportIncluded: {},
        provider: "",
        client: "",
        notes: "",
        paymentId: {
            payment: {
                amount: "",
                razorpay_payment_id: ""
            }
        }
    });

    // useEffects
    useEffect(() => {
        try {
            setIsSessionOpen(props.isOpen);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider Session useEffect1', 'Error in try catch block', err.stack);
        }
    }, [])

    useEffect(() => {
        try {
            if (props.detail) {
                if (props.detail.time.length === 2) {
                    setDuration(moment(props.detail.time[1].to).diff(moment(props.detail.time[0].from), 'minute'));
                } else {
                    setDuration(moment(props.detail.time[0].to).diff(moment(props.detail.time[0].from), 'minute'));
                }
                props.detail.amountPaid = props.detail.paymentId.payment === 'Free Session' ? 0 : Number(props.detail.paymentId.payment.amount);
                props.detail.couponAmount = props.detail.paymentId.payment.coupon ? Number(props.detail.paymentId.payment.coupon.value) : 0;
                props.detail.voucherAmount = props.detail.paymentId.payment.voucher ? Number(props.detail.paymentId.payment.voucher.value) : 0;
                props.detail.totalAmount = props.detail.amountPaid + props.detail.couponAmount + props.detail.voucherAmount;
                props.detail.amountWOTax = Math.round((props.detail.totalAmount - props.detail.couponAmount) / (1 + (props.gstPercentage) / 100));
                props.detail.tax = props.detail.totalAmount - props.detail.amountWOTax;
                // props.detail.razorpayCharges = props.detail.razorpayCharges;
                props.detail.amountEarned = props.detail.amountWOTax// - props.detail.razorpayCharges;
                setSession(props.detail);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider PaymentSession useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.detail]);

    useEffect(() => {
        setIsSessionOpen(props.isOpen);
    }, [props.isOpen])

    // utility functions
    const toggleSession = () => setIsSessionOpen(!isSessionOpen)

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card}>
            <div className="row px-3" onClick={toggleSession} style={{ cursor: "pointer" }}>
                <span style={theme.headingBold}>Session #{props.index > -1 ? props.index + 1 : null} </span>
                <span className="ml-auto" style={theme.headingRegular}>
                    {`${moment(session.date).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format('MMM DD, dddd')} at ${session.time.length > 0 ? session.time.length === 2 ? moment(session.time[0].from).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") + " - " + moment(session.time[1].to).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") : moment(session.time[0].from).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") + " - " + moment(session.time[0].to).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") : null}`}
                    {
                        isSessionOpen
                            ? <span className="ml-3"><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-3"><i className="fas fa-angle-down"></i></span>
                    }
                </span>
            </div>

            <Collapse isOpen={isSessionOpen}>
                <hr />
                <div className="my-auto sessionDiv" style={theme.paragraph}>
                    <Table borderless>
                        <tbody>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Client Name</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.client.title ? session.client.title : ''} {session.client.firstName} {session.client.lastName}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Client Email</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.client.email}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Booked on</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{moment(session.createdAt).format('MMM DD, YYYY [at] hh:mm A')}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Duration</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{duration === 60 ? "1 hour" : "30 minutes"}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Mode of Service</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.modeOfServiceSelected}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Session Report included</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.isReportIncluded ? session.isReportIncluded.status ? `Yes for ₹${session.isReportIncluded.amount}` : "No" : "No"}</span>
                                </td>
                            </tr>
                            {
                                session.couponApplied ?
                                    <tr>
                                        <td className="sessionInfoTitle">
                                            <span>Coupon applied</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">₹{session.couponAmount}</span>
                                        </td>
                                    </tr> : null
                            }
                            {
                                session.voucherApplied ?
                                    <tr>
                                        <td className="sessionInfoTitle">
                                            <span>GiftVoucher applied</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">₹{session.voucherAmount}</span>
                                        </td>
                                    </tr> : null
                            }
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Amount Paid by Client</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">₹{session.amountWOTax}</span>
                                </td>
                            </tr>
                            {/* <tr>
                                <td className="sessionInfoTitle">
                                    <span>Platform Charges</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{`₹${session.platformCharges} (${props.platformChargesPercentage}%)`}</span>
                                </td>
                            </tr> */}
                            <tr>
                                <td className="sessionInfoTitle">
                                    <span>Amount Earned</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">₹{session.amountEarned}</span>
                                </td>
                            </tr>
                            {
                                session.paymentId.payment === 'Free PaymentSession' ? null :
                                    session.paymentId.payment.amount === '0.00' ? null :
                                        <tr>
                                            <td className="sessionInfoTitle">
                                                <span>Transaction ID</span>
                                            </td>
                                            <td>
                                                <span className="sessionInfoDetail">{session.paymentId.payment.razorpay_payment_id}</span>
                                            </td>
                                        </tr>
                            }
                            {
                                session.isRescheduled ?
                                    <tr>
                                        <td className="sessionInfoTitle">
                                            <span>Reschedule requested</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.isRescheduled ? "Yes" : "No"}</span>
                                        </td>
                                    </tr>
                                    : null
                            }
                            {
                                session.isCancelled ?
                                    <tr>
                                        <td className="sessionInfoTitle">
                                            <span>Is refunded</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.refundProcessed ? "Yes" : "No"}</span>
                                        </td>
                                    </tr>
                                    : null
                            }
                        </tbody>
                    </Table>
                </div>
            </Collapse>
        </div>
    )

}

export default PaymentSession;